import { useState } from 'react';
import Main from '../../../component/Main';
import BefScheduled from './BefScheduled';
import AftScheduled from './AftScheduled';
import CurrentInput from './CurrentInput';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle';

function BdTrmsDutyScheduled() {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        { label: '사전 근무표', component: <BefScheduled /> },
        { label: '사후 근무표', component: <AftScheduled /> },
        { label: '입력 현황', component: <CurrentInput /> },
    ];
    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    
    // Dynamic Style Hook
    const { backColor, fontColor, primaryBackColor, lightBorderShadowInColor, primaryShadowColor } = useDynamicStyle();

    return (
        <Main>
            <div className='tab_wrapper'>
                {tabs?.map((tab, idx) => {
                    const selected = activeTab === idx
                    const selectedStyle = primaryBackColor + ' tab_select'
                    return (
                        <div key={idx} className={`tab_title ${backColor} ${fontColor} ${lightBorderShadowInColor} ${primaryShadowColor} ${selected && selectedStyle}`}
                                onClick={() => handleTabClick(idx)}>{tab.label}</div>
                    )}
                )}
            </div>
            {tabs[activeTab].component}
        </Main>
    );
}
export default BdTrmsDutyScheduled;